import EventEmitter from 'events';

export const VIDEO_QUALITY_WATCHER_INTERVAL_FAST = 1000;
export const VIDEO_QUALITY_WATCHER_INTERVAL_SLOW = 5000;

const createVideoQualityWatcher = (deps) => {
  const ee = new EventEmitter();
  const { videoQualityChangedChecker } = deps;
  videoQualityChangedChecker.on('videoQualityChanged', (ev) => {
    ee.emit('videoQualityChanged', ev);
  });
  let interval = deps.interval ?? VIDEO_QUALITY_WATCHER_INTERVAL_FAST;
  let cancelId;
  return Object.assign(ee, {
    start() {
      if (cancelId) {
        // already started
        return;
      }
      cancelId = setInterval(() => {
        videoQualityChangedChecker.check();
      }, interval);
    },

    stop() {
      clearInterval(cancelId);
      cancelId = undefined;
    },

    changeInterval(newInterval) {
      if (newInterval === interval) {
        return;
      }
      interval = newInterval;
      if (cancelId) {
        clearInterval(cancelId);
        cancelId = setInterval(() => {
          videoQualityChangedChecker.check();
        }, interval);
      }
    },

    destroy() {
      this.stop();
      ee.removeAllListeners();
      videoQualityChangedChecker.destroy();
    },
  });
};

export default createVideoQualityWatcher;
